


























import { defineComponent, ref } from '@vue/composition-api';
import { useAuth } from '@/admin/auth';
import { useNotification } from '@/composition/notification';

export default defineComponent({
  name: 'AccountPassword',
  setup(props, context) {
    const auth = useAuth();
    const notification = useNotification();

    const step = ref(1);
    const phoneNumber = ref('');
    const code = ref('');
    const isSending = ref(false);

    const send = async () => {
      if (!phoneNumber) {
        notification.error('電話番号を入力してください');
        return;
      }

      isSending.value = true;
      try {
        await auth.updatePhoneNumber(phoneNumber.value);
        notification.notify('認証コードを送信しました');
        step.value = 2;
      } catch(error) {
        notification.error(error);
      }
      isSending.value = false;
    }

    const verify = async () => {
      if (!code.value) {
        notification.error('認証コードを入力してください');
        return;
      }

      isSending.value = true;
      try {
        await auth.updatePhoneNumberVerify(code.value);
        notification.notify('電話番号を変更しました');
        context.root.$router.push('/account');
      } catch(error) {
        notification.error(error);
      }
      isSending.value = false;
    }

    return { step, phoneNumber, code, isSending, send, verify };
  }
});
